<template>
    <div id="variation-alert-form-component">
        <v-radio-group v-model="configuration.operator" class="mt-1">
            <v-radio value="-">
                <template v-slot:label>
                    <span class="font-14">
                        {{
                            $t(
                                configuration.type === 'variation'
                                    ? 'dialog_update_alert_component.diminution'
                                    : 'dialog_update_alert_component.no_diminution'
                            )
                        }}
                    </span>
                </template>
            </v-radio>

            <v-radio value="+">
                <template v-slot:label>
                    <span class="font-14">
                        {{
                            $t(
                                configuration.type === 'variation'
                                    ? 'dialog_update_alert_component.augmentation'
                                    : 'dialog_update_alert_component.no_augmentation'
                            )
                        }}
                    </span>
                </template>
            </v-radio>
        </v-radio-group>

        <v-text-field
            v-model="configuration.limit"
            :label="$t('dialog_update_alert_component.value')"
            filled
            hide-details
            type="number"
        />

        <p class="my-2">
            {{ $t('dialog_update_alert_component.on') }}
        </p>

        <v-row class="ma-0">
            <v-text-field
                v-model="configuration.variation_time"
                :label="$t('dialog_update_alert_component.value')"
                class="text-field-duo"
                filled
                type="number"
            />
            <v-spacer />
            <v-select
                v-model="configuration.time_unites_selected"
                :items="time_unites"
                :label="$t('dialog_update_alert_component.unity')"
                :menu-props="{ bottom: true, offsetY: true }"
                class="text-field-duo"
                filled
                item-text="label"
                item-value="value"
                return-object
            />
        </v-row>
    </div>
</template>

<script>
export default {
    name: 'VariationAlertFormComponent',
    props: {
        configuration: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            time_unites: [
                {
                    value: 'minute',
                    label: 'minutes',
                },
                {
                    value: 'hours',
                    label: 'heures',
                },
            ],
        }
    },
}
</script>

<style scoped>
.text-field-duo {
    max-width: 49% !important;
}
</style>
